<atlas-modal #modal titleText="Locations" height="90vh">
  <atlas-modal-content width="750px" height="calc(90vh - 52px)">
    <div class="business-navbar__locations-modal__admin-view" *ngIf="(userViewType$ | async) === viewType.USER_VIEW_TYPE_ADMIN">
      <i class="material-icons">info</i>
      <span>{{ 'SWITCH_LOCATION_MODAL.ADMIN_VIEW' | translate:adminViewDefault }}</span>
    </div>
    <div class="business-navbar__locations-modal__container" [ngClass]="{'business-navbar__locations-modal--reduced-height': (userViewType$ | async) === viewType.USER_VIEW_TYPE_ADMIN}">
      <div class="business-navbar__locations-modal__search" [ngClass]="{'business-navbar__locations-modal--fill-top': (userViewType$ | async) === viewType.USER_VIEW_TYPE_SMB}">
        <atlas-search-box (textChange)="textChanged($event)"></atlas-search-box>
      </div>
      <atlas-tab-header *ngIf="showTabs$ | async">
        <atlas-location-tab [label]="allTabText$ | async" [isDefaultSelected]="true"></atlas-location-tab>
        <atlas-location-tab [label]="accountGroupTabText$ | async"></atlas-location-tab>
        <atlas-location-tab [label]="brandTabText$ | async"></atlas-location-tab>
      </atlas-tab-header>
      <div class="business-navbar__locations-modal__list" #listContainer (scroll)="listScroll()">
        <atlas-location-list [locations]="locationService.selectedLocationList$ | async"></atlas-location-list>
        <atlas-loader
          class="business-navbar__locations-modal__loading"
          *ngIf="(locationService.loading$ | async)"
          [size]="50"
        ></atlas-loader>
      </div>
    </div>
  </atlas-modal-content>
  <atlas-modal-footer class="business-navbar__locations-modal__hotkey-help">
    <div class="business-navbar__locations-modal__hotkey-wrapper">
      <div class="business-navbar__locations-modal__hotkey-action">
        <div class="business-navbar__locations-modal__hotkey">
          <i class="material-icons">keyboard_return</i>
        </div>
        <span>{{ 'SWITCH_LOCATION_MODAL.TO_SELECT' | translate:'to Select' }}</span>
      </div>
      <div class="business-navbar__locations-modal__hotkey-action">
        <div class="business-navbar__locations-modal__hotkey">
          <i class="material-icons">keyboard_arrow_up</i>
        </div>
        <div class="business-navbar__locations-modal__hotkey">
          <i class="material-icons">keyboard_arrow_down</i>
        </div>
        <span>{{ 'SWITCH_LOCATION_MODAL.TO_NAVIGATE' | translate:'to Navigate' }}</span>
      </div>
      <div class="business-navbar__locations-modal__hotkey-action" *ngIf="showTabs$ | async">
        <div class="business-navbar__locations-modal__hotkey">{{ 'COMMON.KEYBOARD.SHIFT' | translate:'Shift' }}</div>+&nbsp;
        <div class="business-navbar__locations-modal__hotkey">
          <i class="material-icons">keyboard_arrow_left</i>
        </div>
        <div class="business-navbar__locations-modal__hotkey">
          <i class="material-icons">keyboard_arrow_right</i>
        </div>
        <span>{{ 'SWITCH_LOCATION_MODAL.TO_CHANGE_TABS' | translate:'to Change Tabs' }}</span>
      </div>
      <div class="business-navbar__locations-modal__hotkey-action">
        <div class="business-navbar__locations-modal__hotkey">{{ 'COMMON.KEYBOARD.ESC' | translate:'ESC' }}</div>
        <span>{{ 'SWITCH_LOCATION_MODAL.TO_CLOSE' | translate:'to Close' }}</span>
      </div>
      <div class="business-navbar__locations-modal__hotkey-action">
        <div class="business-navbar__locations-modal__hotkey">{{ 'COMMON.KEYBOARD.SHIFT' | translate:'Shift' }}</div>+&nbsp;
        <div class="business-navbar__locations-modal__hotkey">/</div>
        <span>{{ 'SWITCH_LOCATION_MODAL.TO_OPEN' | translate:'to Open' }}</span>
      </div>
    </div>
  </atlas-modal-footer>
</atlas-modal>
